import { HttpResult } from "widgets-for-react"
import { SubscriptionPrice } from "./subscriptionPriceSelectorState"

export const loadSubscriptionPricesApi = async () => {
    let headers = new Headers()
    headers.append('content-type', 'application/json')

    let res = await fetch(`/api/v1/subscriptions/prices`, {
        method: 'get',
        headers: headers,
    })

    if (!res.ok) throw Error(res.statusText)
        
    let json = await res.json()
    let received = json as SubscriptionPrice[]

    let result: HttpResult<SubscriptionPrice[]> = { kind: "result", value: received, status: 200 }
    return result;
}